/**
 * Questionnaires Page
 *
 * Re-exports the QuestionnairesPage component from questionnaires module.
 */

import { QuestionnairesPage as QuestionnairesPageComponent } from '../questionnaires';

export default QuestionnairesPageComponent;
